import { render, staticRenderFns } from "./ShortenDeadline.vue?vue&type=template&id=d8dbcf2e&"
import script from "./ShortenDeadline.vue?vue&type=script&lang=js&"
export * from "./ShortenDeadline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports